/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponseClinicPathwayDto } from '../../models/response-clinic-pathway-dto';

export interface ClinicPathwaysControllerUpdateStatus$Params {

/**
 * Tenant identifier
 */
  tenant: string;

/**
 * Clinic identifier
 */
  clinicId: string;

/**
 * Pathway type
 */
  type: string;

/**
 * New status for the pathway
 */
  status: 'ACTIVE' | 'INACTIVE' | 'CANCELED';

/**
 * User performing the update
 */
  updatedBy?: string;
}

export function clinicPathwaysControllerUpdateStatus(http: HttpClient, rootUrl: string, params: ClinicPathwaysControllerUpdateStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseClinicPathwayDto>> {
  const rb = new RequestBuilder(rootUrl, clinicPathwaysControllerUpdateStatus.PATH, 'put');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('clinicId', params.clinicId, {});
    rb.path('type', params.type, {});
    rb.path('status', params.status, {});
    rb.query('updatedBy', params.updatedBy, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseClinicPathwayDto>;
    })
  );
}

clinicPathwaysControllerUpdateStatus.PATH = '/thalea-pathways/clinic-pathways/{tenant}/{clinicId}/{type}/status/{status}';
